import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DMSCertificateTableComponent from "./dms-certificate-table.component";
import TableSort from "../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../shared/helpers/upper-case";
import { useQuery } from "@tanstack/react-query";
import { getCertificates } from "../../../../../core/api/services/dms.certificate.service";

const DMSCertificateComponent = () => {
  const [PageNumber, setPageNumber] = useState<number>(1);
  const [dmsCerSearchValue, setDmsCerSearchValue] = useState("");
  const [filters, setFilters] = useState<any>({});
  const pageSize = 10;

  const filter = useSelector((state: any) => {
    return state.certificate.filter;
  });

  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("deviceCode"));
  const [SortDirection, setSortDirection] = useState<any>("desc");

  const [columns, setColumns] = useState([
    {
      title: "Device ID",
      label: "deviceCode",
      isSorted: true,
      // width: "22rem",
      type: "link",
      link: "/admin/dms/device",
      linkableField: "deviceId",
    },
    {
      title: "Issued On",
      label: "issuedOn",
      type: "datetime",
      // width: "14rem",
    },
    {
      title: "Expired On",
      label: "expiredOn",
      type: "date",
      width: "7rem",
    },
    {
      title: "Status",
      label: "status",
    },
  ]);

  useEffect(() => {
    setPageNumber(1);
    setFilters(filter);
  }, [filter]);

  const {
    data: certificates,
    isLoading: isLoadingCertificates,
    refetch,
  } = useQuery({
    queryKey: [
      "getCertificates",
      PageNumber,
      filters?.townCouncil,
      filters?.site,
      filters?.block,
      filters?.device,
      filters?.status,
      filters?.fromDate,
      filters?.toDate,
      SortBy,
      SortDirection,
      dmsCerSearchValue,
    ],
    queryFn: ({ signal }) =>
      getCertificates(
        PageNumber,
        pageSize,
        filters?.townCouncil,
        filters?.site,
        filters?.block,
        filters?.device,
        filters?.status,
        filters?.fromDate,
        filters?.toDate,
        SortBy,
        SortDirection,
        dmsCerSearchValue,
        signal,
      ),
  });

  const onRefetchData = () => {
    if (certificates?.numberOfRecords <= pageSize + 1) {
      setPageNumber(1);
    }
    void refetch();
  };

  const handleChangePage = useCallback((page: number): void => {
    setPageNumber(page);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    [],
  );

  const handleSearch = useCallback((searchVal: string): void => {
    setPageNumber(1);
    setDmsCerSearchValue(searchVal);
  }, []);

  return (
    <div>
      <DMSCertificateTableComponent
        columns={columns}
        data={certificates?.data}
        totalNumberOfRecords={certificates?.numberOfRecords}
        pageSize={pageSize}
        current={PageNumber}
        onChangePage={handleChangePage}
        onRefetchData={onRefetchData}
        onChangeSort={handleChangeSort}
        isLoading={isLoadingCertificates}
        onSearch={handleSearch}
        filter={filter}
      />
    </div>
  );
};

export default DMSCertificateComponent;
